module.exports = "<div class=form-control> <input type=password value={{value}} readonly=readonly class=\"dynamic-form-input ui-width\"> <a href=javascript:; id=edit style=\"color:#2298f4;background:0 0\" class=dynamic-form-input-a>编辑</a> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/components/form/encrypt-input-control/encrypt-input-controL.wx.html
// module id = 1938
// module chunks = 50